module.exports = __webpack_public_path__ + "static/media/sp3.338bbb14.png";